import React from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogProvider } from '@posthog/react'
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';

const sentryEnvironment =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";
const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';

Sentry.init({
  enabled: !isStaging,
  dsn: "https://d76398321ad3bf8b888be94ebc921f4d@o4511090117312512.ingest.us.sentry.io/4511090118754304",
  environment: sentryEnvironment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. 
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  sendDefaultPii: true,
});

// Global error handler to suppress unhandled promise rejections from showing error overlay
// These are typically from background operations like auto-save that should fail silently
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent the error overlay from showing for background operations
  event.preventDefault();
});

// Global error handler for runtime errors
window.addEventListener('error', (event) => {
  // Only suppress errors from async operations, not actual code errors
  if (event.message === 'Script error.') {
    console.error('Generic script error caught:', event);
    event.preventDefault();
  }
});

const posthogKey = process.env.REACT_APP_POSTHOG_KEY || 'phc_if4UEYINnRHptt35AZWhnwgXtYF0IZ00GW49NYyDRfS';
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

// Keep synthetic staging activity out of the production analytics project.
if (!isStaging) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageview: false, // We handle this manually in App.js
    persistence: 'localStorage',
    autocapture: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
